import { call, put } from 'redux-saga/effects';

import api from 'api';

import { notifyError } from 'store/notifications/actions';

import { getBigScreenDeepLinkSuccess } from '../actions';

import { IChannelDeeplinkResponse } from 'types/bigScreen';

export function* getBigScreenSaga() {
    try {
        const deepLink: IChannelDeeplinkResponse = yield call(api.user.getChannelDeepLink);

        yield put(getBigScreenDeepLinkSuccess({ ...deepLink, bigScreenTokenTTL: Date.now() }));
    } catch (error: any) {
        yield put(notifyError({ message: 'message.error.somethingWentWrong' }));
    }
}
